module.exports = __webpack_public_path__ + "static/media/eidBrek.07a7e881.gif";